import migrate_from_v1 from "./garden_v2";
import migrate_from_v2 from "./garden_v3";

export const migrations: { version: number, migrate?: (garden: any) => any }[] = [
    { version: 1 },
    { version: 2, migrate: migrate_from_v1 },
    { version: 3, migrate: migrate_from_v2 }
]